"use client";

import { createContext, useContext, useState } from "react";

export interface MerchantData {
  merchant_id: number;
  district_merchant_id: number;
  user_type: number;
  [key: string]: unknown;
}
export interface UserData {
  id: number;
  name: string;
  email: string;
  [key: string]: unknown;
}

interface GlobalState {
  token: string | null;
  userData: UserData | null;
  merchantData: MerchantData | null;
  merchantId: number | null;
  districtMerchantId: number | null;
  userType: number | null;

  serverData?: ServerData;

  setUserData: (user: UserData | null) => void;
  setMerchantData: (merchant: MerchantData | null) => void;
  setToken: (token: string) => void;

  getAllMenuCat: unknown[];
  getBranches: unknown[];
  getAllTaxes: unknown[];
  getAllOptions: unknown[];
  getMenus: unknown[];
  getAllMenu: unknown[];
  showBranch: unknown[];
  // showBranchDetail: unknown[]
  getPlans: unknown[];
  // showTownship: unknown[]
  // showCity: unknown[]
  getBranchClosingDate: unknown[];
  getProfile: unknown[];
  getUsers: unknown[];
  getShowCategories: unknown[];
  getCategories: unknown[];
  getAllCities: unknown[];
  getAllTownships: unknown[];
  getActiveBranches: unknown[];
  loadErrors?: string[];
}

interface GlobalProviderProps {
  children: React.ReactNode;
  initialToken?: string | null;
  initialUser?: UserData | null; // Add this
  initialMerchant?: MerchantData | null;
  serverData?: {
    getAllMenuCat?: unknown[];
    getBranches?: unknown[];
    getAllTaxes?: unknown[];
    getAllOptions?: unknown[];
    getMenus?: unknown[];
    // showBranchDetail?: unknown[]
    getPlans?: unknown[];
    // showCity?: unknown[]
    // showTownship?: unknown[]
    getTownship?: unknown[];
    getBranchClosingDate?: unknown[];
    getProfile?: unknown[];
    getUsers?: unknown[];
    getShowCategories?: unknown[];
    getCategories?: unknown[];
    getAllCities?: unknown[];
    getAllTownships?: unknown[];
    showBranch?: unknown[];
    getAllMenu?: unknown[];
    getActiveBranches?: unknown[];
    loadErrors?: string[];
  };
}

export interface ServerData {
  getAllMenuCat?: unknown[];
  getBranches?: unknown[];
  showBranch?: unknown;
  getAllTaxes?: unknown[];
  getAllOptions?: unknown[];
  getAllMenu?: unknown[];
  getMenus?: unknown[];
  getPlans?: unknown[];
  getBranchClosingDate?: unknown[];
  getProfile?: unknown;
  getUsers?: unknown[];
  getShowCategories?: unknown[];
  getCategories?: unknown[];
  getAllCities?: unknown[];
  getAllTownships?: unknown[];
  getActiveBranches?: unknown[];
  loadErrors?: string[];
}

const GlobalContext = createContext<GlobalState | undefined>(undefined);

export function GlobalProvider({
  children,
  initialToken,
  initialMerchant,
  initialUser,
  serverData,
}: GlobalProviderProps) {
  // Token and IDs initialized lazily from props
  const [token, setToken] = useState(() => initialToken || "");
  const [userData, setUserDataState] = useState<UserData | null>(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem("userData");
      return stored ? JSON.parse(stored) : initialUser;
    }
    return initialUser ?? null;
  });

  const setUserData = (user: UserData | null) => {
    setUserDataState(user);
    if (typeof window !== "undefined") {
      if (user) {
        localStorage.setItem("userData", JSON.stringify(user));
      } else {
        localStorage.removeItem("userData");
      }
    }
  };
  const [merchantData, setMerchantData] = useState<MerchantData | null>(
    initialMerchant || null,
  );
  const merchantId = merchantData?.merchant_id ?? null;
  const districtMerchantId = merchantData?.district_merchant_id ?? null;
  const userType = merchantData?.user_type ?? null;

  const [getAllMenuCat] = useState(serverData?.getAllMenuCat ?? []);
  const [getBranches] = useState(serverData?.getBranches ?? []);
  const [showBranch] = useState(serverData?.showBranch ?? []);
  const [getAllTaxes] = useState(serverData?.getAllTaxes ?? []);
  const [getAllOptions] = useState(serverData?.getAllOptions ?? []);
  const [getAllMenu] = useState(serverData?.getAllMenu ?? []);
  const [getMenus] = useState(serverData?.getMenus ?? []);

  // const [showBranchDetail] = useState(serverData?.showBranchDetail ?? [])
  const [getPlans] = useState(serverData?.getPlans ?? []);
  // const [showTownship] = useState(serverData?.showTownship ?? [])
  // const [showCity] = useState(serverData?.showCity ?? [])
  const [getBranchClosingDate] = useState(
    serverData?.getBranchClosingDate ?? [],
  );
  const [getProfile] = useState(serverData?.getProfile ?? []);
  const [getUsers] = useState(serverData?.getUsers ?? []);
  const [getShowCategories] = useState(serverData?.getShowCategories ?? []);
  const [getCategories] = useState(serverData?.getCategories ?? []);
  const [getAllCities] = useState(serverData?.getAllCities ?? []);
  const [getAllTownships] = useState(serverData?.getAllTownships ?? []);
  const [getActiveBranches] = useState(serverData?.getActiveBranches ?? []);

  return (
    <GlobalContext.Provider
      value={{
        token,
        userData, // Uncomment this
        merchantData, // Uncomment this
        merchantId,
        districtMerchantId,
        userType,
        serverData,
        setUserData,
        setMerchantData,
        setToken,
        getAllMenuCat,
        getBranches,
        getAllTaxes,
        getAllOptions,
        getAllMenu,
        getMenus,
        getPlans,
        getBranchClosingDate,
        getProfile,
        getUsers,
        getShowCategories,
        showBranch,
        getCategories,
        getAllCities,
        getAllTownships,
        getActiveBranches,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
}

export function useGlobal() {
  const context = useContext(GlobalContext);
  if (!context) throw new Error("useGlobal must be used inside GlobalProvider");
  return context;
}

// 'use client'

// import { createContext, useContext, useState, useEffect } from 'react'

// export interface MerchantData {
//   merchant_id: number
//   district_merchant_id: number
//   user_type: number
//   [key: string]: unknown
// }

// export interface UserData {
//   id: number
//   name: string
//   email: string
//   [key: string]: unknown
// }

// interface GlobalState {
//   token: string | null
//   userData: UserData | null
//   merchantData: MerchantData | null
//   merchantId: number | null
//   districtMerchantId: number | null
//   userType: number | null
//   serverData: any
// }

// interface GlobalProviderProps {
//   children: React.ReactNode
//   initialToken?: string | null
//   initialUser?: UserData | null
//   initialMerchant?: MerchantData | null
//   serverData?: any
// }

// const GlobalContext = createContext<GlobalState | undefined>(undefined)

// export function GlobalProvider({
//   children,
//   initialToken,
//   initialUser,
//   initialMerchant,
//   serverData = {},
// }: GlobalProviderProps) {
//   const [token, setToken] = useState(initialToken ?? '')
//   const [merchantId, setMerchantId] = useState(
//     initialMerchant?.merchant_id ?? null
//   )
//   const [districtMerchantId, setDistrictMerchantId] = useState(
//     initialMerchant?.district_merchant_id ?? null
//   )
//   const [userType, setUserType] = useState(initialMerchant?.user_type ?? null)
//   const [userData] = useState(initialUser ?? null)
//   const [merchantData] = useState(initialMerchant ?? null)

//   // Only sync from props on first render, avoid infinite loops
//   useEffect(() => {
//     if (initialToken && initialToken !== token) setToken(initialToken)
//     if (initialMerchant) {
//       setMerchantId(initialMerchant.merchant_id ?? null)
//       setDistrictMerchantId(initialMerchant.district_merchant_id ?? null)
//       setUserType(initialMerchant.user_type ?? null)
//     }
//   }, [initialToken, initialMerchant])

//   return (
//     <GlobalContext.Provider
//       value={{
//         token,
//         userData,
//         merchantData,
//         merchantId,
//         districtMerchantId,
//         userType,
//         serverData,
//       }}
//     >
//       {children}
//     </GlobalContext.Provider>
//   )
// }

// export function useGlobal() {
//   const context = useContext(GlobalContext)
//   if (!context) throw new Error('useGlobal must be used inside GlobalProvider')
//   return context
// }
